module.exports = __webpack_public_path__ + "img/pushover_settings.7066547b.gif";